import styled from "styled-components";
import customMedia from "../../../../../config/breakpoints";

export const TitleContainer = styled.div`
  width: 70%;
  span {
    color: ${({ theme }) => theme.colors.blue};
  }

  ${customMedia.lessThan("tablet")`
    width: 100%;
  `}
`;
export const SubTitleContainer = styled.div`
  margin-top: 24px;
  width: 100%;

  ${customMedia.greaterThan("desktop")`
    width: 70%;
  `}
`;

export const StepsBlocContainer = styled.div`
  width: 100%;
  margin: 50px 0 40px 0;
`;

export const OrientationContainer = styled.div`
  margin: 80px 0 40px 0;
  width: 100%;
`;

export const TextContainer = styled.div`
  p {
    text-decoration: underline;
  }

  li {
    margin-top: 16px;
  }

  ul {
    margin-left: 20px;
  }
`;

export const UnderlineText = styled.span`
  text-decoration: underline;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;

export const WarningText = styled.span`
  font-style: italic;
`;

export const ListContainer = styled.div`
  margin-bottom: 20px;
`;

export const List = styled.div`
  margin-left: 30px;
`;

export const InfoContainer = styled.div`
  margin-top: 8px;
`;
